module.exports = __webpack_public_path__ + "static/img/DSC_2677.54f2a12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2677.jpg
// module id = 272
// module chunks = 0